import XLSX from 'xlsx';
export function base64(s) {
    return window.btoa(unescape(encodeURIComponent(s)));
}
const useCardSupplier = (type) => {
  return {
    1:'北京移动',
    2:'江门移动',
    3:'重庆卡',
    4:'江西卡',
    5:'深圳卡',
    6:'谷米卡',
    7:'北京移动(新)',
    8:'北京移动(新)',
    9:'北京移动(新)',
    10:'北京移动语音卡',
    11:'深圳移动',
    12:'联通',
    13:'北京移动4G卡',
    14:'惠州联通',
    15:'陕西移动',
    16:'云杉卡',
    17:'齐犇卡',
    18:'北京单4G卡',
  }[type];
}
export function ExportWeb(data, params){
  let jsonData = [];
  data.map(item=>{
    let obj = {
        simCard:String(item.simCard),
        iccid:String(item.iccid),
        cardSupplier:useCardSupplier(item.cardSupplier),
        outOrIn:item.outOrIn == 0?'未出库':'出库',
        simState:item.simState == 1?'正常':item.simState == 2?'过期':item.simState == 3?'销卡':item.simState == 4?'停机':item.simState == 5?'过户':item.simState == 6?'休眠':item.simState == 7?'未激活':'正常',
        traffic:item.traffic+'KB',
        surplusGprs:item.surplusGprs+'KB',
        simType:item.simType>1024?parseInt(item.simType/1024)+'G':item.simType+'M',
        openTime:item.openTime||'',
        activationTime:item.activationTime||'',
        expireTime:item.expireTime||'',
        userName:item.userName,
        remarks:'',
        renewDate:item.renewDate || '',
      }
      jsonData.push(obj);
  })
  console.log(jsonData);
  if (!jsonData.length) return false;
    //列标题
    let str =
        "<tr><td>SIM卡号</td><td>ICCID</td><td>卡商</td><td>库存状态</td><td>SIM卡状态</td><td>总流量</td><td>剩余流量</td><td>套餐类型</td><td>开卡日期</td><td>激活时间</td><td>过期时间</td><td>客户代码</td><td>备注</td><td>续费时间</td></tr>";
    //循环遍历，每行加入tr标签，每个单元格加td标签
    for (let i = 0; i < jsonData.length; i++) {
        str += "<tr>";
        for (let item in jsonData[i]) {
        //增加\t为了不让表格显示科学计数法或者其他格式
        str += `<td style="mso-number-format:'\@';">${jsonData[i][item] + "\t"}</td>`;
        
        }
        str += "</tr>";
    }
    //Worksheet名
    let worksheet = "Sheet1";
    let uri = "data:application/vnd.ms-excel;base64,";

    //下载的表格模板数据
    let template = `<html xmlns:o="urn:schemas-microsoft-com:office:office"
    xmlns:x="urn:schemas-microsoft-com:office:excel"
    xmlns="https://www.w3.org/">
    <head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>
        <x:Name>${worksheet}</x:Name>
        <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>
        </x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
        </head><body><table>${str}</table></body></html>`;
    //下载模板
    // window.location.href = uri + this.base64(template);
    var a = document.createElement("a"); //为了给xls文件命名，重新创建一个a元素
    a.href = uri + base64(template); // 给a元素设置 href属性
    a.download =
        "SIM卡信息" + new Date().getTime() + ".xlsx"; // 给a元素设置下载名称
    jsonData = [];
    a.click();
}
export function exportExcel(json, name) {
    /* convert state to workbook */
    var data = new Array();
    var keyArray = new Array();
    let jsonData = [];
    json.map(item=>{
        let obj = {
            '客户代码':item.userName,
            'SIM卡号':String(item.simCard),
            'ICCID':String(item.iccid),
            '套餐类型':item.simType>1024?parseInt(item.simType/1024)+'G':item.simType+'M',
            '总流量':item.traffic+'KB',
            '剩余流量':item.surplusGprs+'KB',
            'SIM卡状态':item.simState == 1?'正常':item.simState == 2?'过期':item.simState == 3?'销卡':item.simState == 4?'停机':item.simState == 5?'过户':item.simState == 6?'休眠':item.simState == 7?'未激活':'正常',
            '库存状态':item.outOrIn == 0?'未出库':'出库',
            '开卡日期':item.openTime||'',
            '激活时间':item.activationTime||'',
            '过期时间':item.expireTime||'',
            '卡商':useCardSupplier(item.cardSupplier),
            '备注':item.remark,
            '续费时间':item.renewDate || '',
          }
          jsonData.push(obj);
      })
    for (const key1 in jsonData) {
        if (jsonData.hasOwnProperty(key1)) {
            const element = jsonData[key1];
            var rowDataArray = new Array();
            for (const key2 in element) {
                if (element.hasOwnProperty(key2)) {
                    const element2 = element[key2];
                    rowDataArray.push(element2);
                    if (keyArray.length < getLength(element)) {
                        keyArray.push(key2);
                    }
                }
            }
            data.push(rowDataArray);
        }
    }
    data.splice(0, 0, keyArray);
    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
    /* generate file and send to client */
    XLSX.writeFile(wb, "SIM卡信息" + new Date().getTime() + ".xls");
}
export function getLength(obj) {
    var count = 0;
    for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
            count++;

        }
    }
    return count;
}